import React from 'react';
import { Button, ButtonProps } from '@mui/material';

interface Props extends ButtonProps {
  onClick?: () => void;
}
export const HwtButton: React.FC<Props> = ({
  children: text,
  onClick,
  size,
  variant,
  style,
  color = 'inherit',
  ...props
}: Props) => {
  return (
    <Button size={size} variant={variant} color={color} {...props} sx={style} onClick={onClick}>
      {text}
    </Button>
  );
};
